const INTERPOLATION_STEP = 0;
const INTERPOLATION_LINEAR = 1;
const INTERPOLATION_CUBIC = 2;

export { INTERPOLATION_CUBIC, INTERPOLATION_LINEAR, INTERPOLATION_STEP };
